/* eslint-disable no-await-in-loop */
import cloneDeep from 'lodash.clonedeep';

import { uploadContestAsset } from '~/services/contests/contests.service.api';
import { AssetType } from '~/services/contests/enums/contests-assets.enums';

const getAssetTypeByKey = (key: string): AssetType => {
  if (key === 'banner') return AssetType.CONTEST_BANNER;
  if (key === 'thumbnail') return AssetType.CONTEST_THUMBNAIL;
};

const asyncProcessImageFile = async (
  obj: Record<string, unknown>,
  key: string,
  file: File
): Promise<void> => {
  try {
    const data = await uploadContestAsset({ assetType: getAssetTypeByKey(key), file });
    obj[key] = data;
  } catch {
    obj[key] = undefined; // TODO: could check that image was not uploaded in summary
  }
};

const processFormValues = async (obj: Record<string, unknown>): Promise<void> => {
  const entries = Object.entries(obj);

  for (const [key, value] of entries) {
    if (value instanceof File) {
      await asyncProcessImageFile(obj, key, value);
    } else if (typeof value === 'object' && value !== null) {
      await processFormValues(value as Record<string, unknown>);
    }
  }
};

export const replaceImageFilesWithAvatarURL = async (
  obj: Record<string, unknown>
): Promise<Record<string, unknown>> => {
  const clonedObj = cloneDeep(obj);
  await processFormValues(clonedObj);
  return clonedObj;
};
